export * from './base-data.service';



// WEBPACK FOOTER //
// ./src/app/shared/abstract/index.ts